<script setup>
const props = defineProps({
  icon: Object,
  label: String,
  value: String,
  trend: String,
  positive: Boolean
})
</script>

<template>
  <div class="rounded-lg bg-background/50 border border-border/30 p-4">
    <div class="flex items-center gap-2 mb-2">
      <component :is="icon" class="w-4 h-4 text-accent/70" />
      <span class="text-xs text-muted-foreground">{{ label }}</span>
    </div>
    <div class="flex items-baseline gap-2">
      <span class="text-2xl font-bold text-foreground">{{ value }}</span>
      <span :class="['text-xs', positive ? 'text-accent' : 'text-destructive']">
        {{ trend }}
      </span>
    </div>
  </div>
</template>
